/*
  PDP rating badge — green pill placed after the Judge.me star rating.
  Paired with snippets/pdp-rating-badge.liquid (emits #pdp-rating-badge-data)
  and pdp-rating-badge.css.

  Part of the shoes PDP A/B test — renders for the `dropdown` group only
  (assets/pdp-ab-group.js owns the group; this file just subscribes).

  ATTACH POINT: appended to `.jdgm-preview-badge`, the OUTER wrapper the theme renders
  (see the `single_product_preview_badge` case in the gp-section snippets). Judge.me's
  script replaces the INNER `.jdgm-prev-badge` when it hydrates, so anchoring inside that
  would have our badge wiped on load. Appending to the outer wrapper survives it — and a
  MutationObserver re-attaches anyway if Judge.me replaces the wrapper wholesale.
*/
(function () {
  if (window.__prbBound) return;
  window.__prbBound = true;

  var dataEl = document.getElementById('pdp-rating-badge-data');
  if (!dataEl) return;

  var TEXT;
  try {
    TEXT = ((JSON.parse(dataEl.textContent) || {}).text || '').trim();
  } catch (e) {
    return;
  }
  if (!TEXT) return;

  var MARK = 'data-prb';
  // Put on the host while our badge lives there, so the CSS that turns it into a single
  // row is scoped to exactly that case and never touches a rating row we did not modify.
  var HOST_MARK = 'data-prb-host';
  var observer = null;
  var scheduled = false;

  // Outer wrapper first (theme-owned, survives Judge.me hydration); the inner badge is a
  // fallback for surfaces that render it without the wrapper.
  var HOSTS = ['.jdgm-preview-badge', '.jdgm-prev-badge'];

  function findHost() {
    for (var i = 0; i < HOSTS.length; i += 1) {
      var found = document.querySelectorAll(HOSTS[i]);
      for (var n = 0; n < found.length; n += 1) {
        // The PDP can carry more than one rating row (sticky bar, tabs); only attach to
        // one that is actually on screen, never to a hidden duplicate.
        if (!found[n].getClientRects().length) continue;
        return found[n];
      }
    }
    return null;
  }

  function build() {
    var badge = document.createElement('span');
    badge.className = 'pdp-rating-badge';
    badge.setAttribute(MARK, '');
    badge.textContent = TEXT;
    return badge;
  }

  function detach() {
    var existing = document.querySelectorAll('[' + MARK + ']');
    for (var i = 0; i < existing.length; i += 1) existing[i].remove();
    var hosts = document.querySelectorAll('[' + HOST_MARK + ']');
    for (var h = 0; h < hosts.length; h += 1) hosts[h].removeAttribute(HOST_MARK);
  }

  function attach() {
    var host = findHost();
    if (!host) return false;
    var current = host.querySelector('[' + MARK + ']');
    // Already in place on the right host — leave it be rather than thrashing the DOM.
    if (current && current.parentNode === host) return true;
    detach();
    host.setAttribute(HOST_MARK, '');
    host.appendChild(build());
    return true;
  }

  function activeGroup() {
    // Fail safe to control: if the shared resolver did not load, add nothing rather than
    // giving every shopper the test experience and spoiling the split.
    if (!window.pdpAb) return 'control';
    return window.pdpAb.refresh();
  }

  function render() {
    scheduled = false;
    if (observer) observer.disconnect();
    if (activeGroup() === 'dropdown') attach();
    else detach();
    if (observer) observer.observe(document.body, { childList: true, subtree: true });
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    setTimeout(render, 120);
  }

  function init() {
    observer = new MutationObserver(schedule);
    render();
    if (window.pdpAb && typeof window.pdpAb.onChange === 'function') {
      window.pdpAb.onChange(schedule);
    }
    // Judge.me loads its widget script asynchronously — the rating row is often not in
    // the DOM yet, and gets repainted once it is.
    [300, 800, 1500, 2500].forEach(function (t) {
      setTimeout(schedule, t);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
